
import zpagenav from '@/components/inc/pageblock.vue' // 分页
import chain from '@/components/inc/chain.vue' // 产业链 
import loading from '@/components/inc/loading.vue' // loading动画 
import tipspop from '@/components/inc/tipspop.vue' // 提示弹窗
import leftnav from '@/components/inc/leftnav.vue' // 左侧菜单栏  
import govheader from '@/components/inc/govheader.vue' // 政府端底部菜单 
import videoTeaching from '@/components/inc/VideoTeaching.vue';
import rightNav from '@/components/inc/rightNav.vue';
import operatdemo from '@/components/inc/operatDemo.vue';
import finacingTime from '@/components/inc/finacingTime.vue'; //融资时间的统一展示
import notionScreen from '@/components/inc/notionScreen.vue'; //企业列表概念notion筛选统一展示
import cityScreen from '@/components/inc/cityScreen.vue'; //省市区筛选统一展示
import watermark from '@/components/inc/watermark.vue' //水印
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue" //二维码提示框

//*表格统一*/
import domesticTable from '@/components/inc/table/domesticTable.vue'; //全部内资企业表格
import innovateTable from '@/components/inc/table/innovateTable.vue'; //创新企业表格

import vedioTips from '@/components/inc/vedio-tips.vue' //水印
import findProjectsTab from '@/components/project/inc/findProjectsTab.vue' //找项目tab切换





export default (Vue) => {
	Vue.component('zpagenav', zpagenav)
	Vue.component('chain', chain)
	Vue.component('loading', loading)
	Vue.component('tipspop', tipspop)
	Vue.component('leftnav', leftnav)
	Vue.component('govheader', govheader)
	Vue.component('videoTeaching', videoTeaching);
	Vue.component('rightNav', rightNav);
	Vue.component('operatDemo', operatdemo);
	Vue.component('finacingTime', finacingTime);
	Vue.component('notionScreen', notionScreen);
	Vue.component('cityScreen', cityScreen);
	Vue.component('domesticTable', domesticTable);
	Vue.component('innovateTable', innovateTable);
	Vue.component('watermark', watermark);
	Vue.component('freeUserTips', freeUserTips);
	Vue.component('vedioTips', vedioTips);
	Vue.component('findProjectsTab', findProjectsTab);
	
	
	

}